import { doc, onSnapshot } from "firebase/firestore";
import { useState, createContext, useEffect } from "react";
import { firestore } from "../firebaseInit";
import { currentSchoolYear } from "../config/currentSchoolYear";

export const MaintenanceContext = createContext();

export const MaintenanceProvider = (props) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

  // establishes a snapshot listener, which gets changes to the cloud version in realtime
  const setMaintenanceListener = () => {
    return onSnapshot(
      doc(firestore, `systemSettings`, `${currentSchoolYear}`),
      (doc) => {
        const settingsData = { ...doc.data() };
        setIsMaintenanceMode(settingsData.isMaintenanceMode);
      },
      (error) => {
        // ...
      }
    );
  };

  // subscribe to maintenance mode changes
  useEffect(() => {
    const unsubscribe = setMaintenanceListener();
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <MaintenanceContext.Provider
      value={{
        isMaintenanceMode,
        setIsMaintenanceMode,
      }}
    >
      {props.children}
    </MaintenanceContext.Provider>
  );
};
